import React from 'react'

function HomeFeatures() {
    return (
        <div>
              <section className="mt-15 md:mt-40 pb-40 relative bg-blueGray-100">
       
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center">
            <div className="w-10/12 md:w-6/12 lg:w-4/12 px-4 6 md:px-4 mr-auto ml-auto ">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-lightBlue-500">
                <img
                  alt="..."
                  
                  src="https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  className="w-full align-middle rounded-t-lg"
                />
                <blockquote className="relative p-4 mb-4">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    className="absolute left-0 w-full block h-95-px -top-94-px"
                  >
                   
                  </svg>
                  <h4 className="text-xl font-bold text-neutral text-brandHeadline">
                  Why choose us?
                  </h4>
                
                </blockquote>
              </div>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="flex flex-wrap">
                <div className="w-full md:w-6/12 px-4">
                  <div className="group relative mt-4 overflow-hidden rounded-[1.5rem] border border-white/10 bg-white p-1 shadow-[0_18px_45px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(123,47,255,0.16)]">
                    <div className="rounded-[1.35rem] bg-gradient-to-br from-white via-white to-brandHeadline/5 px-4 py-5 transition-colors duration-300 group-hover:from-brandHeadline/5 group-hover:to-brandButton/10">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-white shadow-md ring-1 ring-brandHeadline/10 transition-transform duration-300 group-hover:scale-105">
                        <i className="fas fa-sitemap"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold text-brandHeadline">
                      Availability
                      </h6>
                      <p className="mb-0 text-blueGray-500">
                      A team dedicated to your project to ensure that your objectives are achieved
                      </p>
                    </div>
                  </div>
                  <div className="group relative mt-4 overflow-hidden rounded-[1.5rem] border border-white/10 bg-white p-1 shadow-[0_18px_45px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(123,47,255,0.16)]">
                    <div className="rounded-[1.35rem] bg-gradient-to-br from-white via-white to-brandHeadline/5 px-4 py-5 transition-colors duration-300 group-hover:from-brandHeadline/5 group-hover:to-brandButton/10">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-white shadow-md ring-1 ring-brandHeadline/10 transition-transform duration-300 group-hover:scale-105">
                        <i className="fas fa-drafting-compass"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold text-brandHeadline">
                      Dynamic
                      </h6>
                      <p className="mb-0 text-blueGray-500">
                      Dynamic and proactive management of your projects
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-6/12 px-4">
                  <div className="group relative mt-4 overflow-hidden rounded-[1.5rem] border border-white/10 bg-white p-1 shadow-[0_18px_45px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(123,47,255,0.16)]">
                    <div className="rounded-[1.35rem] bg-gradient-to-br from-white via-white to-brandHeadline/5 px-4 py-5 transition-colors duration-300 group-hover:from-brandHeadline/5 group-hover:to-brandButton/10">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-white shadow-md ring-1 ring-brandHeadline/10 transition-transform duration-300 group-hover:scale-105">
                        <i className="fas fa-newspaper"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold text-brandHeadline">innovative</h6>
                      <p className="mb-0 text-blueGray-500">
                      Innovative and cutting-edge digital solutions to propel your business online
                      </p>
                    </div>
                  </div>
                  <div className="group relative mt-4 overflow-hidden rounded-[1.5rem] border border-white/10 bg-white p-1 shadow-[0_18px_45px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(123,47,255,0.16)]">
                    <div className="rounded-[1.35rem] bg-gradient-to-br from-white via-white to-brandHeadline/5 px-4 py-5 transition-colors duration-300 group-hover:from-brandHeadline/5 group-hover:to-brandButton/10">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-white shadow-md ring-1 ring-brandHeadline/10 transition-transform duration-300 group-hover:scale-105">
                        <i className="fas fa-file-alt"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold text-brandHeadline">
                      Creativity
                      </h6>
                      <p className="mb-0 text-blueGray-500">
                      Overflowing creativity 3 to distinguish you from your competitors
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
        </div>
    )
}

export default HomeFeatures
